import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { INotification } from 'src/app/shared/models/core/notification.model';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'ben-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnDestroy {
  notifications: INotification[] = [];
  showBanner: boolean = false;  
  subscription: Subscription;
  showCloseButton: boolean = true;
  
  constructor(private notificationService: NotificationService) {
      this.subscription = this.notificationService.getMessageChanges().subscribe(notification => {
        this.notifications.push(notification);
        this.checkForNotifications();
        if(notification.autoDismiss){
          this.autoClearMessage(notification.id);
        }
      });
     }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

    hide(id: string) {
      this.notifications = this.notifications.filter((n)=>{
        return n.id != id;
      })
      this.checkForNotifications();
    }

    autoClearMessage(id: string) {
      setTimeout(() => {
        this.hide(id);
      }, 5000);
    }

    checkForNotifications(){
      this.showBanner = this.notifications.length > 0;
    }
    getOffset(index: number){
      return `${index * 65}px`;
    }
}
